import React, {useContext, useState} from 'react';
import './SelectLanguage.less';
import {Button} from "elements/button/Button";
import {SelectList} from "compositions/select-list/SelectList";
import {DrawerPopup} from "dialog-layout/drawer-popup/DrawerPopup.tsx";
import {getSafeTranslation} from "helpers/localization.helper.ts";
import {TranslationsContext} from "contexts/translations-context";
import {SelectListItem} from "compositions/select-list-item/SelectListItem.tsx";
import {Checkbox} from "elements/checkbox/Checkbox.tsx";

export const SELECT_LANGUAGE_POPUP = 'SELECT_LANGUAGE_POPUP';

export const SelectLanguage = ({languages, defaultLanguage, onCancelClick, onDoneClick, onOverlayClick}) => {
	const [selectedLanguage, setSelectedLanguage] = useState(defaultLanguage);

	const translations = useContext(TranslationsContext);

	return <DrawerPopup
		title={getSafeTranslation('SelectLanguagePopup.title', translations)}
		onOverlayClick={onOverlayClick}
		leftControl={<Button isText onClick={onCancelClick}>{
			getSafeTranslation('SelectLanguagePopup.cancelButtonCaption', translations)
		}</Button>}
		rightControl={<Button isText onClick={() => onDoneClick(selectedLanguage)}>{
			getSafeTranslation('SelectLanguagePopup.doneButtonCaption', translations)
		}</Button>}
	>
		<div className="select-language">
			<SelectList>
				{
					languages.map(language => {
						const isSelected = language === selectedLanguage;

						return (<SelectListItem
							checkboxControl={<Checkbox isChecked={isSelected} isRadio/>}
							key={language}
							name={getSafeTranslation(`languageCode${language.toUpperCase()}`, translations)}
							isSelected={isSelected}
							onClick={() => setSelectedLanguage(language)}
						/>)
					})
				}
			</SelectList>
		</div>
	</DrawerPopup>
}
